import React from 'react';
import { cn } from '../../utils/cn'; // Assuming we might need a utility, but I'll inline the logic if cn doesn't exist or just use template literals
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'dark' | 'darker' | 'accent';
}
export function Section({
  children,
  className = '',
  id,
  background = 'dark'
}: SectionProps) {
  const backgrounds = {
    dark: 'bg-slate-900',
    darker: 'bg-slate-950',
    accent: 'bg-slate-800' // #1E293B
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 w-full ${backgrounds[background]} ${className}`} data-id="element-153">
      <div className="max-w-6xl mx-auto" data-id="element-154">{children}</div>
    </section>;
}